export const CgnSalaryControl = new RegExp(
    /^\d+(.\d{3})*(,\d{1,2})?$/i
  );

  